import { useTranslations } from "next-intl";

import myaccount from "~/components/common/myaccount.module.scss";

import styles from "./payment.module.scss";

export default function Payments() {
  const t = useTranslations();

  return (
    <>
      <div className={myaccount.myaccountCard}>
        <div className={myaccount.myaccountCardHeader}>
          <h2>{t("generic.myaccount.payments.title")}</h2>
        </div>
        <div className={styles.paymentsListWrapper}>
          <p className={styles.emptyMessage}>{t("generic.myaccount.payments.empty")}</p>
          {/* <ul className={styles.addressesList}>
            <li className={styles.paymentListCard}>
              <Icon name={"mastercard"} aria-hidden width={20} height={20} className={styles.paymentCardIcon} />
              <div className={styles.paymentListCardText}>
                <p className={styles.paymentListCardName}>Mastercard</p>
                <p>ending with 4567 · expiring 12/26</p>
                <Button lookAsLink>{t("generic.remove")}</Button>
              </div>
              <Icon name={"star-full"} aria-hidden width={16} height={16} className={styles.paymentCardIcon} />
            </li>
            <li className={styles.paymentListCard}>
              <Icon name={"visa"} aria-hidden width={20} height={20} className={styles.paymentCardIcon} />
              <div className={styles.paymentListCardText}>
                <p className={styles.paymentListCardName}>Visa</p>
                <p>ending with 4567 · expired 12/22</p>
                <div className={styles.poaymentCardActions}>
                  <Button lookAsLink>{t("generic.remove")}</Button>
                  <Button lookAsLink>{t("generic.setfavourite")}</Button>
                </div>
              </div>
            </li>
            <li className={styles.paymentListCard}>
              <Icon name={"maestro"} aria-hidden width={20} height={20} className={styles.paymentCardIcon} />
              <div className={styles.paymentListCardText}>
                <p className={styles.paymentListCardName}>Maestro</p>
                <p>ending with 4567 · expiring 12/26</p>
                <div className={styles.poaymentCardActions}>
                  <Button lookAsLink>{t("generic.remove")}</Button>
                  <Button lookAsLink>{t("generic.setfavourite")}</Button>
                </div>
              </div>
            </li>
          </ul> */}
        </div>
      </div>
    </>
  );
}
